import { CatalogSectionContent } from 'src/types/contentBlocks';
import { CatalogBlock } from 'src/uikit/CatalogBlock';

const DEFAULT_TITLE = 'Доступные сервисы платформы';

export function CatalogSection(props: CatalogSectionContent['data']) {
  const { id, title = DEFAULT_TITLE, categories = [], products = [] } = props;

  return (
    <CatalogBlock
      id={id}
      title={title}
      categories={categories}
      products={products}
    />
  );
}
